/* eslint-disable no-empty-function */

/**
 * do nothing async
 */
export const noopAsync = async function noopAsyncFunction() {};

/**
 * do nothing
 */
export const noop = function noopFunction() {};
